import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import FontIcon from 'components/FontIcon';
import BuildChildren from 'utils/BuildChildren';
import SearchButtonA from 'components/SearchButton/SearchButtonA';
import classes from './SiteNavADesktopLevelA.module.scss';

const SiteNavADesktopLevelA = (props) => {
  const {
    imageUrl,
    imageLinkHref,
    imageLinkTarget,
    imageAltText,
    contactHref,
    contactTarget,
    button,
    items = [],
    searchResultsLinkHref,
    siteId,
    itemsCount,
    cartUrl,
  } = props;

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <Link
          href={imageLinkHref}
          target={imageLinkTarget}
          className={classes.logo}
        >
          <img
            src={imageUrl}
            alt={imageAltText}
            height={47}
            width={240}
          />
        </Link>
        <div className={classes.navItemList}>
          {items.filter((i) => i.isVisible).map((item) => {
            const className = item.isActive ? classes.navItemActive : classes.navItem;
            return (
              <Link
                href={item.href}
                target={item.target}
                className={className}
                key={item.href}
                dangerouslySetInnerHTML={{ __html: item.heading }}
              />
            );
          })}
        </div>
        <div className={classes.rightNav}>
          <Link
            href={cartUrl}
            className={classes.icon}
          >
            <FontIcon icon='far fa-shopping-cart' className={classes.iconCart}>
              {itemsCount > 0 ? <span className={classes.badge}>{itemsCount}</span> : null}
            </FontIcon>
          </Link>

          {contactHref && (
            <Link
              href={contactHref}
              target={contactTarget}
              className={classes.icon}
            >
              <FontIcon icon='far fa-phone' className={classes.iconPhone} />
            </Link>
          )}

          {button.subType && BuildChildren(button)}
          <SearchButtonA
            siteSearch360SiteId={siteId}
            siteSearch360SiteResults={searchResultsLinkHref}
            searchQueryString='search'
          />
        </div>
      </div>
    </div>
  );
};

SiteNavADesktopLevelA.propTypes = {
  items: PropTypes.array.isRequired,
  imageUrl: PropTypes.string,
  imageLinkHref: PropTypes.string,
  imageLinkTarget: PropTypes.string,
  imageAltText: PropTypes.string,
  contactHref: PropTypes.string,
  contactTarget: PropTypes.string,
  button: PropTypes.object,
  searchResultsLinkHref: PropTypes.string,
  siteId: PropTypes.string,
  itemsCount: PropTypes.number,
  cartUrl: PropTypes.string,
};

export default SiteNavADesktopLevelA;
